import { render, staticRenderFns } from "./SectionDownloadables.vue?vue&type=template&id=00f0e291&scoped=true&"
import script from "./SectionDownloadables.vue?vue&type=script&lang=js&"
export * from "./SectionDownloadables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f0e291",
  null
  
)

export default component.exports